import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import './QuizNormal.css';
import { api_url } from "../../constant/constant";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import { useTranslation } from "react-i18next";

const QuizNormal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lesson = location.state?.lesson;
  const { t } = useTranslation();

  const [quizData, setQuizData] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [totalScore, setTotalScore] = useState(0);
  const assessments = location.state?.assessments;
  const [assessment,setassessments]=useState([]);
  const [assessmentCompleted, setassessmentCompleted] = useState(false);

  useEffect(() => {
    if (lesson?.quiz) {
      const filteredQuiz = lesson.quiz.filter(q => !q.answered);
      setQuizData(filteredQuiz);
      setAnswers(Array(filteredQuiz.length).fill(null));
      // if (filteredQuiz.length === 0) setQuizCompleted(true);
      if (filteredQuiz.length === 0) {
        setassessmentCompleted(true);

        setassessments([assessments]);
      } 
        

    }
          // if (filteredQuiz.length === 0) setQuizCompleted(true);

   
  }, [lesson]);

  const handleAnswerSelect = (index) => {
    const newAnswers = [...answers];
    newAnswers[currentQuestion] = index;
    setAnswers(newAnswers);
  };

  const handleNext = () => {
    if (answers[currentQuestion] === null) {
      setError(t("pleaseselectanoptionbeforeproceeding"));
      showToast(t("pleaseselectanoptionbeforeproceeding"), "error");
      return;
    }

    setError("");

    if (currentQuestion < quizData.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    } else {
      handleSubmitAllAnswers();
    }
  };

  const handleSubmitAllAnswers = async () => {
    setLoading(true);
    try {
      const payload = {
        answers: quizData.map((q, i) => ({
          question_id: q.question_id,
          answer_id: q.options[answers[i]]?.option_id
        }))
      };

      console.log("Submitting all answers:", payload);

      const response = await fetch(`${api_url}/user/submit-quiz-answer/${quizData[0].question_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Batch submit response:", data);

      if (!response.ok || data.status !== "success") {
        showToast(t("failedtosubmitanswer"), "error");
        setLoading(false);
        return;
      }

      const total = data.per_question?.reduce((acc, q) => acc + (q.score || 0), 0) || 0;
      setTotalScore(total);
      setQuizCompleted(true);
      showToast(t("answersubmittedsuccessfully"), "success");
    } catch (error) {
      console.error("Error submitting all answers:", error);
      showToast(t("erroroccurredwhilesubmittinganswer"), "error");
    }
    setLoading(false);
  };

  if (quizCompleted) {
    const totalQuestions = quizData.length;
    const correctAnswers = totalScore / 100;
    const avgValue = (correctAnswers / totalQuestions) * 100;
    const average = avgValue % 1 === 0 ? avgValue.toFixed(0) : avgValue.toFixed(2);

    return (
      <div className="quiz-container">
        <h2>{t("ThanksforSubmittingQuiz")}</h2>
        <div className="result-summary mt-4">
          <p>
            <strong>{correctAnswers}</strong> {t("answerscorrectoutof")}{" "}
            <strong>{totalQuestions}</strong> {t("questions")}
          </p>
          <hr />
          <p className="fs-5 mt-3">
            <strong>{t("TotalScore")}</strong> {correctAnswers} / {totalQuestions}
          </p>
          <p className="fs-5 mt-2">
            <strong>{t("Average")}</strong> {average}%
          </p>
        </div>
        <div className="finish-btn mt-4">
          <button className="btn btn-primary" onClick={() => navigate("/user/dashboard")}>
            {t("Finish")}
          </button>
        </div>
      </div>
    );
  }
  if (assessmentCompleted) {
    const AssessmentArr = assessment;
    console.log("assessmets",assessment);
    const correctAnswers = AssessmentArr[0]?.correct_count;
    const totalQuestions = AssessmentArr[0]?.total_questions;
    const average = AssessmentArr[0].percentage.toFixed(0);

    return (
      <div className="quiz-container">
        <h2>{t("ThanksforSubmittingQuiz")}</h2>
        <div className="result-summary mt-4">
          <p>
            <strong>{correctAnswers}</strong> {t("answerscorrectoutof")}{" "}
            <strong>{totalQuestions}</strong> {t("questions")}
          </p>
          <hr />
          <p className="fs-5 mt-3">
            <strong>{t("TotalScore")}</strong> {correctAnswers} / {totalQuestions}
          </p>
          <p className="fs-5 mt-2">
            <strong>{t("Average")}</strong>: {average}%
          </p>
        </div>
        <div className="finish-btn mt-4">
          <button className="btn btn-primary" onClick={() => navigate("/user/dashboard")}>
            {t("Finish")}
          </button>
        </div>
      </div>
    );
  }
  if (!quizData) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{t("Loading...")}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="quiz-container">
      <h2>{quizData[currentQuestion]?.question}</h2>
      <div className="options">
        {quizData[currentQuestion]?.options.map((option, index) => (
          <label key={option.option_id} className="option">
            <input
              type="radio"
              name={`question-${currentQuestion}`}
              checked={answers[currentQuestion] === index}
              onChange={() => handleAnswerSelect(index)}
              disabled={loading}
            />
            {option.answer}
          </label>
        ))}
      </div>
      {error && <div className="error-message">{error}</div>}
      {loading && <div className="loading-text">{t("Submittinganswer...")}</div>}
      <div className="quiz-buttons">
        <button onClick={handleNext} disabled={loading}>
          {currentQuestion === quizData.length - 1 ? t("Finish") : t("Next")}
        </button>
      </div>
    </div>
  );
};

export default QuizNormal;
